module.exports = __webpack_public_path__ + "assets/img/flag-task-seoCheckUp.bd2fd880.svg";